import { render } from "./Sentinelles.vue?vue&type=template&id=5596afc0"
import script from "./Sentinelles.vue?vue&type=script&lang=js"
export * from "./Sentinelles.vue?vue&type=script&lang=js"

import "./Sentinelles.vue?vue&type=style&index=0&id=5596afc0&lang=css"
script.render = render

export default script